module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "gap"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7933d41d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1460
// module chunks = 1